import { createAction } from 'redux-actions';
import { FlightSeatMapFragment } from '@websky/graphql';

export const setSeatMap = createAction<FlightSeatMapFragment>('SET_SEAT_MAP');

export type SetSeatMapAction = ReturnType<typeof setSeatMap>;
